import { DeleteTwoTone, EditTwoTone } from "@material-ui/icons";
import { IconButton, Tooltip } from "@mui/material";
import React from "react";
import { GeneralContainer, Content } from "./SOSInstantMessages.styled";
import { theme as themeConfig } from "../../themes/themes";

const SOSInstantMessages = ({ messages, handleEdit, handleDelete }) => {
  return (
    <GeneralContainer className="message-content">
      {messages.map((record) => {
        return (
          <Content key={record?.instanceMessageId}>
            <label>{record?.message}</label>
            <div className="icon-container">
              <Tooltip title="Edit">
                <IconButton onClick={() => handleEdit(record)}>
                  <EditTwoTone style={{ color: themeConfig.neutral.gray[2600] }} />
                </IconButton>
              </Tooltip>
              <Tooltip title="Delete">
                <IconButton onClick={() => handleDelete(record)}>
                  <DeleteTwoTone
                    style={{
                      color: themeConfig.neutral.gray[2600],
                    }}
                  />
                </IconButton>
              </Tooltip>
            </div>
          </Content>
        );
      })}
    </GeneralContainer>
  );
};

export default SOSInstantMessages;
